.faq-type-2 {
  &__header {
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    margin-bottom: var(--spacing-4xl);

    .me-heading {
      margin: 0 auto var(--spacing-lg);

      @include desktop {
        margin-bottom: var(--spacing-xl);
      }
    }

    .me-text {
      @include text-line-clamp(3);

      overflow: hidden;
      font-size: map-get($font-sizes, md);

      @include desktop {
        font-size: map-get($font-sizes, lg);
        margin-bottom: var(--spacing-2xl);
      }
    }
  }

  &--dark {
    background-color: var(--color-neutral-neutral-darker);
    color: var(--color-neutral-white);
  }

  &__row {
    .faq-type-2__column {
      margin-bottom: 0;
    }
  }

  &__accordion {
    display: flex;
    flex-direction: column;
    width: 100%;

    &--border-full {
      gap: var(--spacing-xs);

      .faq-type-2__item {
        border: 1px solid var(--color-neutral-black);
        padding: var(--spacing-lg);

        @include desktop {
          padding: var(--spacing-xl);
        }

        .faq-type-2__item-header {
          padding: 0;
        }

        &.faq-type-2__item--open .faq-type-2__item-content {
          padding: var(--spacing-lg) 0 0;

          @include desktop {
            padding-top: var(--spacing-xl);
          }
        }
      }
    }
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    position: relative;
    border-top: 1px solid var(--color-neutral-black);

    &:last-child {
      border-bottom: 1px solid var(--color-neutral-black);
    }

    &:focus-within:has(*:focus-visible) {
      outline: var(--border-size-md) solid var(--color-brand-primary-light) !important;
      outline-offset: var(--border-size-md);
      border-radius: var(--radius-size-sm);
      z-index: 1;
    }

    &-header {
      width: 100%;
      padding: var(--spacing-md) 0;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-align: left;

      @include desktop {
        padding: var(--spacing-xl) 0 var(--spacing-lg);
      }

      &:focus {
        outline: none;
      }

      .faq-type-2__item-title {
        @include text-line-clamp(2);

        overflow: hidden;
        font-size: map-get($font-sizes, md);
        line-height: map-get($line-heights, md);
        font-weight: map-get($font-weights, bold);

        @include desktop {
          font-size: map-get($font-sizes, lg);
          line-height: map-get($line-heights, lg);
        }
      }
    }

    &-icon {
      transition: 0.2s all ease;
    }

    &-content {
      display: grid;
      grid-template-rows: 0fr;
      width: 100%;
      overflow: hidden;
      transition: grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &-content-inner {
      min-height: 0;
      overflow: hidden;
      font-size: map-get($font-sizes, md);
      line-height: map-get($line-heights, md);
      font-weight: map-get($font-weights, normal);
      padding-bottom: 0;
      transition: padding-bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1);

      > :last-child {
        margin-bottom: 0;
      }
    }

    &--open {
      .faq-type-2__item-icon {
        transform: rotate(180deg);
      }

      .faq-type-2__item-content {
        grid-template-rows: 1fr;
      }

      .faq-type-2__item-content-inner {
        padding-bottom: var(--spacing-xl);

        @include desktop {
          padding-bottom: var(--spacing-2xl);
        }
      }
    }
  }
}
